import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withFetch,
} from '@angular/common/http';
import { RefererInterceptor } from './services/referer.interceptor';
import { SHEETS_CONFIG } from './services/sheets-config';
import { MEDIA_CONFIG } from './services/media-config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    NotFoundComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatListModule,
    RouterModule,
    AppRoutingModule,
  ],
  providers: [
    { provide: SHEETS_CONFIG, useValue: { base: '/api/sheets', key: '' } },
    { provide: MEDIA_CONFIG, useValue: { base: '/api/media' } },
    { provide: HTTP_INTERCEPTORS, useClass: RefererInterceptor, multi: true },
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
